<template>
  <div class="toolbar">
    <!-- <Emotion :height="200" v-show="false"></emotion>  -->
    <AttachFile v-if="SpeakPermission"></AttachFile>
    <Upload v-if="SpeakPermission"></Upload>
    <Prodbuy :roomInfo="roomInfo" :staffInfo="staffInfo" v-show="OrderPermission"></Prodbuy>
    <SaleBusinessCard v-if="SpeakPermission"></SaleBusinessCard>
  </div>
</template>
<script>
import Global from "@/components/Global";
import AttachFile from "@/components/AttachFile";
import Upload from "@/components/Upload";
import Prodbuy from "@/components/SalesTool/Prodbuy";
import SaleBusinessCard from "@/components/SalesTool/SaleBusinessCard";
import store from "@/vuex/store_chat.js";

export default {
  name: "tool-bar",
  props: ["roomInfo", "staffInfo"],
  data() {
    return {
      //SpeakPermission: false
    };
  },
  components: {
    AttachFile,    
    Upload,
    Prodbuy,
    SaleBusinessCard
  },
  created() {
    // Global.proxy.on("checkSpeaker", speaker => {      
    //   this.SpeakPermission = speaker.indexOf(Global.current_staffid) >= 0;      
    // });
  },
  computed: {
    OrderPermission() {
      return (
        this.roomInfo.MainContactName != null &&
        this.roomInfo.MainContactName == this.staffInfo.StaffName &&
        this.roomInfo.LeadSn != null &&
        this.SpeakPermission
      );
    },
    SpeakPermission() {
      var flag = store.state.reload;
      var speaker = store.state.speaker;
      return speaker.indexOf(Global.current_staffid) >= 0;
    }
  },
  methods: {}
};
</script>




// WEBPACK FOOTER //
// src/components/ToolBar.vue